import {TranslationKey} from '../keys'
import {TRANSLATION_AUTH_EN} from './auth'
import {TRANSLATION_FORKYGRAM_EN} from './forkygram'
import {TRANSLATION_GIFT_SHOP_EN} from './gift-shop'
import {TRANSLATION_GLOBAL_EN} from './global'
import {TranslationResource} from '../TranslationType'

export const TRANSLATION_EN: TranslationResource<TranslationKey> = {
  translation: {
    ...TRANSLATION_GLOBAL_EN.translation,
    ...TRANSLATION_AUTH_EN.translation,
    ...TRANSLATION_GIFT_SHOP_EN.translation,
    ...TRANSLATION_FORKYGRAM_EN.translation,
  },
}
